export const CREATE_LOGOUT_AUDITLOG_MUTATION = gql`
    mutation createLogoutAuditLog {
        createLogoutAuditLog
    }
`;
